import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';

import '@/assets/css/transition.css';

import '@/utils/Filters/index';

import '@/utils/Directive/index';

import '@/utils/Directive/vant.js';

import Swiper from 'swiper/dist/js/swiper.js';
import 'swiper/dist/css/swiper.css';
Vue.prototype.$swiper = Swiper;

import filterXSS from 'xss'
Vue.prototype.$filterXSS = (params) => filterXSS(params)

import Layer from '@/utils/Layer/index';
import '@/utils/Layer/style.css';
Vue.prototype.$layer = Layer;

const Bus = {
  install: () => {
    Vue.prototype.$Bus = new Vue();
  }
};
Vue.use(Bus);


window.Hls = require('hls.js');
// 播放器
require('@/assets/xwPlayer/html5Player.css');
const xwPlayer = require('@/assets/xwPlayer/html5Player.js');
require('@/assets/xwMobilePlayer/html5Player.css');
const mobilePlayer = require('@/assets/xwMobilePlayer/html5Player.js');
Vue.prototype.$xwPlayer = xwPlayer.default;
Vue.prototype.$xwMobilePlayer = mobilePlayer.default;
const Cookie = require('js-cookie');
Vue.prototype.$cookie = Cookie;
require('@/utils/deviceId');
const PhotoSwipe = require('vue-photoswipe.js');
require('vue-photoswipe.js/dist/static/css/photoswipe.css');
Vue.use(PhotoSwipe.default, {
  wechat: window.wx,
  pswpOptions: {
    showShare: false,
    showClose: true,
    showFullscreen: false,
    showZoom: false
  }
});
// const VConsole = require('vconsole');
// eslint-disable-next-line no-new
// new VConsole();

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
